export enum ThemeID {
    ADMIN = 'admin',
    AB = 'ab',
    BB = 'bb',
    BI = 'bi',
    BR = 'br',
    MH = 'mh',
    RW = 'rw',
    VI = 'vi',
    SC = 'sc',
    VN = 'vn',
    VP = 'vp',
    VPBE = 'vpbe',
    WH = 'wh',
}
